// @ts-nocheck
import io from 'socket.io-client';
import store from '../redux/store';
import { socketUrl } from '../config';
import {
    MAX_PAGE_SIZE,
    PAGINATION_KEYS,
    SOCKET_CONTEXT_PAGES,
    SOCKET_UPDATE_TYPES,
    TICKET_CHANGE_TYPES,
} from './constants';
import {
    setCurrentEvent,
    setMonitoringEvents,
    setMonitoringSports,
    updateEventMarkets,
} from '../redux/actions/monitoring';
import { setBetMonitorData } from '../redux/actions/reports';
import { changeErrorModalProps, setAppVersion, updateActionBlockData } from '../redux/actions/global';
import { setPagination } from '../redux/actions/pagination';
import moment from 'moment';
import { setDepositsWithdrawals } from '../redux/actions/payment';
import { deleteNotification, receiveNotification } from '../redux/actions/notifications';
import { notification } from 'antd';

const { dispatch } = store;

const socket = io(socketUrl, {
    transports: ['websocket'],
    reconnectionDelayMax: 1000,
    forceNew: true,
});

let connectionCounter = 0;

socket.on('connect', () => {
    connectionCounter++;

    const reduxStore = store.getState();

    const socketContext = reduxStore.socket.context;

    updateSocket('context-update', socketContext);

    if (connectionCounter > 1 && Object.keys(socketContext).length > 0) {
        dispatch(
            changeErrorModalProps({
                isVisible: true,
                error: { title: 'Socket connection lost.', description: 'Please reload page.' },
            }),
        );
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    }
});

socket.on('ticket-update', payload => {
    try {
        const reduxStore = store.getState();
        const { reports, newReportIds, wonReportIds, cashOutReportIds, startedEventReportIds } =
            reduxStore.reports.betsMonitor;

        const { ticketChangeType } = payload;

        let newReports = reports;

        if (ticketChangeType === TICKET_CHANGE_TYPES.CREATED) {
            newReports = [payload, ...newReports];

            const maxAllowedPageSize = Math.max(reports.length, MAX_PAGE_SIZE);

            if (newReports.length > maxAllowedPageSize) {
                newReports.pop();

                dispatch(
                    setPagination(PAGINATION_KEYS.betsMonitor, {
                        hasMore: true,
                    }),
                );
            }

            const hasStartedPreMatchEvent = payload.selections.some(
                selection => !selection.live && selection.details.scheduleTime < moment().valueOf(),
            );

            newReportIds.push(payload.id);

            if (hasStartedPreMatchEvent) {
                startedEventReportIds.push(payload.id);
            }

            dispatch(
                setBetMonitorData({
                    newReportIds,
                    startedEventReportIds,
                }),
            );

            setTimeout(() => {
                const reduxStore = store.getState();
                let { newReportIds } = reduxStore.reports.betsMonitor;

                newReportIds = newReportIds.filter(id => id !== payload.id);

                dispatch(
                    setBetMonitorData({
                        newReportIds,
                    }),
                );
            }, 3000);
        } else if (
            ticketChangeType === TICKET_CHANGE_TYPES.CANCELLED ||
            ticketChangeType === TICKET_CHANGE_TYPES.CANCELLED_MANUALLY ||
            ticketChangeType === TICKET_CHANGE_TYPES.TICKET_SETTLED ||
            ticketChangeType === TICKET_CHANGE_TYPES.BET_GROUP_SETTLED ||
            ticketChangeType === TICKET_CHANGE_TYPES.TICKET_PAYOUT ||
            ticketChangeType === TICKET_CHANGE_TYPES.TICKET_ROLLBACK_CANCEL ||
            ticketChangeType === TICKET_CHANGE_TYPES.TICKET_ROLLBACK_SETTLEMENT ||
            ticketChangeType === TICKET_CHANGE_TYPES.TICKET_CASH_OUT
        ) {
            const foundTicket = reports.find(ticket => ticket.id === payload.id);

            if (foundTicket) {
                newReports = mergeTickets(reports, payload);

                const changedTicket = newReports.find(ticket => ticket.id === payload.id);

                if (changedTicket.ticketSubStatus === 'WON') {
                    const unchangedTickets = newReports.filter(ticket => ticket.id !== payload.id);
                    newReports = [changedTicket, ...unchangedTickets];

                    wonReportIds.push(changedTicket.id);
                    dispatch(
                        setBetMonitorData({
                            wonReportIds,
                        }),
                    );
                    setTimeout(() => {
                        const wonReportIds = store
                            .getState()
                            .reports.betsMonitor.wonReportIds.filter(id => id !== changedTicket.id);
                        dispatch(
                            setBetMonitorData({
                                wonReportIds,
                            }),
                        );
                    }, 3000);
                }
                if (changedTicket.ticketSubStatus === 'CASH_OUT') {
                    const unchangedTickets = newReports.filter(ticket => ticket.id !== payload.id);
                    newReports = [changedTicket, ...unchangedTickets];

                    cashOutReportIds.push(changedTicket.id);
                    dispatch(
                        setBetMonitorData({
                            cashOutReportIds,
                        }),
                    );
                    setTimeout(() => {
                        const cashOutReportIds = store
                            .getState()
                            .reports.betsMonitor.cashOutReportIds.filter(id => id !== changedTicket.id);
                        dispatch(
                            setBetMonitorData({
                                cashOutReportIds,
                            }),
                        );
                    }, 3000);
                }
            }
        }

        dispatch(
            setBetMonitorData({
                reports: newReports,
            }),
        );
    } catch (error) {
        console.error(error);
    }
});

socket.on('event-update', payload => {
    try {
        const { type } = payload;
        const reduxStore = store.getState();
        const { context } = reduxStore.socket;
        const dateRanges = reduxStore.monitoring.dateRange;

        if (type === SOCKET_UPDATE_TYPES.eventUpdate || type === SOCKET_UPDATE_TYPES.mainMarketUpdate) {
            const {
                type: messageType,
                live,
                eventId,
                sportId,
                categoryId,
                longEventId,
                timestamp,
                ...eventProps
            } = payload;

            // update event page
            if (context.page === SOCKET_CONTEXT_PAGES.monitoringMarkets) {
                const event = reduxStore.monitoring.currentEvent;

                if (
                    eventProps.liveStatistics &&
                    JSON.stringify(event.liveStatistics) !== JSON.stringify(eventProps.liveStatistics)
                ) {
                    dispatch(
                        setCurrentEvent({
                            ...event,
                            liveStatistics: eventProps.liveStatistics,
                        }),
                    );
                }

                return;
            }

            // update tournaments (monitoring page)
            const tournaments = reduxStore.monitoring.events.list;

            // if (context.status !== 'all' && context.status !== payload.statusName) return;

            if (eventProps.newScheduleDate) {
                eventProps.scheduleDate = eventProps.newScheduleDate;
                delete eventProps.newScheduleDate;
            }

            let hasUpdate = false;

            const newTournaments = tournaments.map(tournament => {
                if (tournament.id === longEventId) {
                    const newEvents = tournament.events.map(event => {
                        if (event.id === eventId) {
                            Object.entries(eventProps).forEach(([key, value]) => {
                                const currentValue = event[key];

                                if (value !== currentValue) {
                                    hasUpdate = true;
                                }
                            });
                            return { ...event, ...eventProps };
                        }
                        return event;
                    });

                    return {
                        ...tournament,
                        events: newEvents,
                    };
                }

                return tournament;
            });

            if (hasUpdate) {
                dispatch(setMonitoringEvents(newTournaments));
            }

            return;
        }

        if (type === SOCKET_UPDATE_TYPES.eventAdd) {
            const { type: messageType, live, eventId, sportId, categoryId, timestamp, ...eventData } = payload;

            if (live !== context.live) return;
            if (payload.scheduleDate < dateRanges.startDate || payload.scheduleDate > dateRanges.endDate) {
                return;
            }

            eventData.id = eventId;
            const sports = reduxStore.monitoring.sports.list;
            const tournaments = reduxStore.monitoring.events.list;
            let isSportsUpdated = false;
            let isEventsUpdated = false;

            const newSports = sports.map(sport => {
                if (sport.id === payload.sportId) {
                    const newCategories = sport.categories.map(category => {
                        if (category.id === payload.categoryId) {
                            const newLeagues = category.leagues.map(league => {
                                if (league.id === eventData.longEventId) {
                                    isSportsUpdated = true;
                                    return {
                                        ...league,
                                        eventCount: league.eventCount + 1,
                                    };
                                }

                                return league;
                            });

                            return { ...category, leagues: newLeagues };
                        }

                        return category;
                    });

                    return {
                        ...sport,
                        categories: newCategories,
                    };
                }

                return sport;
            });

            const newTournaments = tournaments.map(tournament => {
                if (tournament.id === eventData.longEventId) {
                    isEventsUpdated = true;
                    return {
                        ...tournament,
                        events: [...tournament.events, eventData],
                    };
                }

                return tournament;
            });

            if (isSportsUpdated) {
                dispatch(setMonitoringSports(newSports));
            } else {
                console.log('not found', payload, sports);
            }

            if (isEventsUpdated) {
                dispatch(setMonitoringEvents(newTournaments));
            }
        }

        if (type === SOCKET_UPDATE_TYPES.eventRemove) {
            const { live, eventId, sportId, categoryId, longEventId } = payload;

            if (live !== context.live) return;
            if (payload.scheduleDate < dateRanges.startDate || payload.scheduleDate > dateRanges.endDate) {
                return;
            }

            const sports = reduxStore.monitoring.sports.list;
            const tournaments = reduxStore.monitoring.events.list;
            let isSportsUpdated = false;
            let isEventsUpdated = false;

            const newSports = sports.map(sport => {
                if (sport.id === sportId) {
                    const newCategories = sport.categories.map(category => {
                        if (category.id === categoryId) {
                            const newLeagues = category.leagues.map(league => {
                                if (league.id === longEventId) {
                                    isSportsUpdated = true;
                                    return {
                                        ...league,
                                        eventCount: league.eventCount - 1,
                                    };
                                }

                                return league;
                            });

                            return { ...category, leagues: newLeagues };
                        }

                        return category;
                    });

                    return {
                        ...sport,
                        categories: newCategories,
                    };
                }

                return sport;
            });

            const newTournaments = tournaments.map(tournament => {
                if (tournament.id === longEventId) {
                    const foundEvent = tournament.events.find(event => event.id === eventId);
                    let newEvents = tournament.events;

                    if (foundEvent) {
                        isEventsUpdated = true;
                        newEvents = newEvents.filter(event => event.id !== eventId);
                    }

                    return {
                        ...tournament,
                        events: newEvents,
                    };
                }

                return tournament;
            });

            if (sports.length && isSportsUpdated) {
                dispatch(setMonitoringSports(newSports));
            }

            if (tournaments.length && isEventsUpdated) {
                dispatch(setMonitoringEvents(newTournaments));
            }
        }
    } catch (error) {
        console.error(error);
    }
});

socket.on('market-update', payload => {
    try {
        const { type, marketGroups } = payload;

        const reduxStore = store.getState();

        if (type === SOCKET_UPDATE_TYPES.marketUpdate) {
            const currentEvent = reduxStore.monitoring.currentEvent;

            const currentMarketsById = currentEvent.markets.reduce(
                (result, market) => ({
                    ...result,
                    [market.id]: market,
                }),
                {},
            );

            if (!payload.markets && !marketGroups) {
                const { type, sportId, categoryId, longEventId, eventId, live, timestamp, ...marketProps } = payload;
                const newEventMarkets = currentEvent.markets.map(market => ({ ...market, ...marketProps }));

                dispatch(setCurrentEvent({ ...currentEvent, ...marketProps, markets: newEventMarkets }));
                return;
            }

            const payloadMarketsById = payload.markets.reduce(
                (result, market) => ({
                    ...result,
                    [market.id]: market,
                }),
                {},
            );

            if (marketGroups) {
                const marketPayload = payload.markets[0];

                Object.keys(currentMarketsById).forEach(marketId => {
                    const hasMatchedMarketGroup = currentMarketsById[marketId].marketGroups.find(group =>
                        marketGroups.includes(group),
                    );

                    if (hasMatchedMarketGroup) {
                        if (marketPayload.outcomes) {
                            marketPayload.outcomes = marketPayload.outcomes.map(outcome => {
                                const newOutcome = { ...outcome };

                                const foundOutcome = currentMarketsById[marketId].outcomes?.find(
                                    o => o.outcomeRefId === outcome.outcomeId,
                                );

                                if (foundOutcome) {
                                    if (newOutcome.odd > foundOutcome.odd) {
                                        newOutcome.changeType = 'increase';
                                    } else if (newOutcome.odd < foundOutcome.odd) {
                                        newOutcome.changeType = 'decrease';
                                    } else {
                                        newOutcome.changeType = '';
                                    }
                                }

                                return newOutcome;
                            });
                        }
                        currentMarketsById[marketId] = { ...currentMarketsById[marketId], ...marketPayload };
                    }
                });
            } else {
                Object.keys(payloadMarketsById).forEach(marketId => {
                    const { id, marketRefId, ...marketProps } = payloadMarketsById[marketId];

                    if (currentMarketsById[marketId]) {
                        if (marketProps.outcomes) {
                            marketProps.outcomes = marketProps.outcomes.map(outcome => {
                                const newOutcome = { ...outcome };

                                const foundOutcome = currentMarketsById[marketId].outcomes?.find(
                                    o => o.outcomeRefId === outcome.outcomeRefId,
                                );

                                if (foundOutcome) {
                                    if (newOutcome.oddValue > foundOutcome.oddValue) {
                                        newOutcome.changeType = 'increase';
                                    } else if (newOutcome.oddValue < foundOutcome.oddValue) {
                                        newOutcome.changeType = 'decrease';
                                    } else {
                                        newOutcome.changeType = '';
                                    }
                                }

                                return newOutcome;
                            });
                        }

                        currentMarketsById[marketId] = { ...currentMarketsById[marketId], ...marketProps };
                    } else {
                        if (!payloadMarketsById[marketId].outcomes) {
                            console.error('market without outcomes', payloadMarketsById[marketId]);
                        }
                        currentMarketsById[marketId] = payloadMarketsById[marketId];
                    }
                });
            }

            const currentMarkets = Object.values(currentMarketsById);

            dispatch(updateEventMarkets(currentMarkets));
        }
    } catch (error) {
        console.error(error);
    }
});

export const handleSocketNotifications = notificationPayload => {
    const { type, content, timestamp } = notificationPayload;

    const id = store.getState().notifications.notificationsList.length + 1;

    store.dispatch(receiveNotification({ id, type, content, timestamp }));

    if (type === 'error') {
        notification.error({
            message: content,
            key: id,
            duration: null,
            onClose() {
                store.dispatch(deleteNotification(id));
            },
        });
    } else {
        notification.success({
            message: content,
            key: id,
            duration: null,
            onClose() {
                store.dispatch(deleteNotification(id));
            },
        });
    }
};

socket.on('notifications', handleSocketNotifications);

socket.on('payment-notifications', handleSocketNotifications);

socket.on('risk-update', payload => {
    try {
        const reduxStore = store.getState();
        const { items } = payload;

        const tournaments = reduxStore.monitoring.events.list;

        let hasUpdate = false;

        const newTournaments = tournaments.map(tournament => {
            const newEvents = tournament.events.map(event => {
                const homeMarketId = `${event.id}${event.marketHash}${event.homeOutcomeId}`;
                const drawMarketId = `${event.id}${event.marketHash}${event.drawOutcomeId}`;
                const awayMarketId = `${event.id}${event.marketHash}${event.awayOutcomeId}`;
                const foundHomeRiskValue = items.find(item => item.uniqueLineId === homeMarketId);
                const foundDrawRiskValue = items.find(item => item.uniqueLineId === drawMarketId);
                const foundAwayRiskValue = items.find(item => item.uniqueLineId === awayMarketId);
                const updatedValues = {};

                if (foundHomeRiskValue) {
                    hasUpdate = true;
                    updatedValues.homeRiskFactorValue = foundHomeRiskValue.riskFactorValue;
                }

                if (foundDrawRiskValue) {
                    hasUpdate = true;
                    updatedValues.drawRiskFactorValue = foundDrawRiskValue.riskFactorValue;
                }

                if (foundAwayRiskValue) {
                    hasUpdate = true;
                    updatedValues.awayRiskFactorValue = foundAwayRiskValue.riskFactorValue;
                }

                return { ...event, ...updatedValues };
            });

            return {
                ...tournament,
                events: newEvents,
            };
        });

        if (hasUpdate) {
            dispatch(setMonitoringEvents(newTournaments));
        }
    } catch (error) {
        console.error(error);
    }
});

socket.on('version-update', async payload => {
    try {
        const { version } = payload;

        dispatch(setAppVersion(version));
    } catch (error) {
        console.error(error);
    }
});

socket.on('monitoring-sale-update', payload => {
    try {
        const reduxStore = store.getState();

        const { eventId, openBets, payout, totalTurnover, tournamentId } = payload;
        const tournaments = reduxStore.monitoring.events.list;

        let hasUpdate = false;

        const newTournaments = tournaments.map(tournament => {
            if (tournament.id !== tournamentId) return tournament;

            const newEvents = tournament.events.map(event => {
                if (event.id !== eventId) return event;

                hasUpdate = true;

                return {
                    ...event,
                    openBets,
                    payout,
                    totalTurnover,
                };
            });

            return {
                ...tournament,
                events: newEvents,
            };
        });

        if (hasUpdate) {
            dispatch(setMonitoringEvents(newTournaments));
        }
    } catch (error) {
        console.error(error);
    }
});

socket.on('block-update', payload => {
    try {
        const { active, type } = payload;

        // const reduxStore = store.getState();
        // const prevState = reduxStore.global.actionBlock.actions.find(action => action.type === type);
        //
        // if (prevState.active !== active) {
        //     const message = `All ${ACTION_BLOCK_TEXTS.find(action => action.type === type)?.text} is ${
        //         active ? 'Blocked' : 'Unblocked'
        //     }!`;
        //
        //     notification.warning({ message });
        // }

        dispatch(updateActionBlockData({ active, type }));
    } catch (error) {
        console.error(error);
    }
});

socket.on('payment-update', payload => {
    try {
        const reduxStore = store.getState();
        const { reports } = reduxStore.payment.depositsWithdrawals;

        const messageModel = JSON.parse(payload.messageModel);

        const formattedPayload = {
            ...messageModel,
            operationType: payload.operationType,
        };

        let newReports = [];

        if (formattedPayload.operationType === 'CREATE') {
            newReports = reports.find(report => report.transactionId === formattedPayload.transactionId)
                ? reports
                : [formattedPayload, ...reports];
        } else {
            newReports = reports.map(report =>
                report.transactionId === formattedPayload.transactionId ? formattedPayload : report,
            );
        }

        dispatch(
            setDepositsWithdrawals({
                reports: newReports,
            }),
        );
    } catch (error) {
        console.error(error);
    }
});

const mergeTickets = (tickets, payload) => {
    return tickets.map(ticket => {
        if (ticket.id === payload.id) {
            const newSelections = ticket.selections.map(selection => {
                const payloadSelection = payload.selections.find(s => s.id === selection.id);

                return {
                    ...selection,
                    status: payloadSelection.status,
                    subStatus: payloadSelection.subStatus,
                };
            });

            return {
                ...ticket,
                ticketStatus: payload.ticketStatus,
                ticketSubStatus: payload.ticketSubStatus,
                cancelledTime: payload.cancelledTime,
                cancelledAgent: payload.cancelledAgent,
                printLimitExceeded: payload.printLimitExceeded,
                expiredAt: payload.expiredAt,
                paymentBlocked: payload.paymentBlocked,
                paymentIssuedAgent: payload.paymentIssuedAgent,
                payoutWinAmount: payload.payoutWinAmount,
                payoutAmount: payload.payoutAmount,
                paidAt: payload.paidAt,
                finalWinTaxAmount: payload.finalWinTaxAmount,
                finalBonusAmount: payload.finalBonusAmount,
                finalPayAmount: payload.finalPayAmount,
                finalWinAmount: payload.finalWinAmount,
                closedAt: payload.closedAt,
                selections: newSelections,
            };
        }

        return ticket;
    });
};

export default socket;

export const updateSocket = (event, data) => {
    socket.emit(event, data);
};

export const formatBetsMonitorContext = context => {
    const formattedContext = {};

    Object.keys(context).forEach(key => {
        if (Array.isArray(context[key])) {
            formattedContext[key] = '';
        } else {
            formattedContext[key] = context[key];
        }
    });

    return formattedContext;
};
